import { riderApi } from '../api/riders';
import { isApiError } from '../api/errors';

/**
 * Whether the signed-in rider may work, asked of InGo's API
 * (`GET rider/me/application`; InGo ADR 0014: the account active and the
 * application approved).
 *
 * Four answers, and the fourth is the one that matters most: `unknown` when
 * the question could not be asked (no signal, the server down). A rider is
 * never signed out or sent back to their application for that: the old
 * check's note (2026-09-03) records a cold start on a weak connection
 * signing riders out on every transient error.
 *
 * @returns {Promise<{ state: 'working' } | { state: 'waiting', refusal: string, application: object } | { state: 'signed-out' } | { state: 'unknown' }>}
 */
export async function riderStanding(rider = riderApi) {
  try {
    const application = await rider.application();

    if (application.may_work === true) {
      return { state: 'working' };
    }

    return { state: 'waiting', refusal: application.refusal ?? '', application };
  } catch (error) {
    // The token is gone or refused: this session is over (the client has
    // already forgotten the token).
    if (isApiError(error) && error.status === 401) {
      return { state: 'signed-out' };
    }

    return { state: 'unknown' };
  }
}
